export const QUOTE_PERMISSIONS = {
  read: 'quotes.read',
  create: 'quotes.create',
  edit: 'quotes.modify',
  delete: 'quotes.delete',
  print: 'quotes.print',
  export: 'quotes.export',
  viewLinks: 'quotes.links',
} as const;
